import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Home from './screens/Home';
import Loading from './components/Loading';
import Query from './screens/Query';
import Organization from './screens/Organization';
import Navbar from './components/Navbar';
import { useOrganization } from './context/organization';
import PricingPlans from './screens/PricingPlans';
import MembersPage from './screens/Members';
import AcceptInvitePage from './screens/AcceptInvite';
import CreditsPage from './screens/Credits';
import Tasks from './screens/Satellite/Tasks';
import TasksForAdmin from './screens/Satellite/TasksForAdmin';
import AcledLicensePage from './screens/AcledLicensePage';
import RouteChangeTracker from './RouteChangeTracker';
import DatapointPricingAdminPage from './screens/Admin/DatapointPricing';
import SdkConfigurationPage from './screens/Sdk/Configuration';
import SdkContextsPage from './screens/Sdk/Contexts';
import PopulationReportsPage from './screens/Reports/Population';
import RoadTrafficReportsPage from './screens/Reports/RoadTraffic';

interface ProtectedRouteProps {
  component: React.ComponentType<any>;
}

const Router: React.FC = () => {
  return (
    <>
      <RouteChangeTracker />

      <Routes>

        <Route path='/' element={<ProtectedRoute component={Home} />} />
        <Route path='/organization' element={<ProtectedRoute component={Organization} />} />
        <Route path='/query' element={<ProtectedRoute component={Query} />} />
        <Route path='/members' element={<ProtectedRoute component={MembersPage} />} />
        <Route path='/manage-plan' element={<ProtectedRoute component={PricingPlans} />} />
        <Route path='/join/:inviteCode' element={<ProtectedRoute component={AcceptInvitePage} />} />
        <Route path='/satellite/tasks' element={<ProtectedRoute component={Tasks} />} />
        <Route path='/credits' element={<ProtectedRoute component={CreditsPage} />} />
        <Route path='/acled-license' element={<ProtectedRoute component={AcledLicensePage} />} />
        <Route path='/reports/population' element={<ProtectedRoute component={PopulationReportsPage} />} />
        <Route path='/reports/road-traffic' element={<ProtectedRoute component={RoadTrafficReportsPage} />} />
        <Route path='/sdk/configuration' element={<ProtectedRoute component={SdkConfigurationPage} />} />
        <Route path='/sdk/contexts' element={<ProtectedRoute component={SdkContextsPage} />} />

        {/* Admin Routes */}
        <Route path='/satellite-image-tasks' element={<ProtectedRoute component={TasksForAdmin} />} />
        <Route path='/admin/datapoint-pricing' element={<ProtectedRoute component={DatapointPricingAdminPage} />} />
      </Routes>
    </>
  );
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component }) => {
  const { organization, loading } = useOrganization();
  const location = window.location.pathname;
  const isJoinRoute = /^\/join\/[^/]+$/.test(location);

  if (loading) {
    return <Loading />;
  }

  const ComponentToRender =
    !organization && !isJoinRoute && location !== '/organization'
      ? () => {
          return null;
        }
      : component;

  const AuthComponent = withAuthenticationRequired(ComponentToRender, {
    onRedirecting: () => <Loading />,
    loginOptions: {
      appState: { returnTo: location },
    },
    returnTo: location,
  });

  return (
    <>
      <Navbar />
      <AuthComponent />
    </>
  );
};

export default Router;
